/* Murmure — helper Runway : redimensionne la photo, lance la génération (async) et interroge le résultat. */
(function () {
  "use strict";
  window.MURMURE = window.MURMURE || {};

  window.MURMURE.resizeToDataURL = function (file, maxDim) {
    maxDim = maxDim || 1280;
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, maxDim / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var c = document.createElement("canvas");
        c.width = cw; c.height = ch;
        c.getContext("2d").drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(url);
        try { resolve(c.toDataURL("image/jpeg", 0.9)); } catch (e) { reject(e); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error("image_load_failed")); };
      img.src = url;
    });
  };

  function endpoint() { return (window.MURMURE_RUNWAY_ENDPOINT || "").replace(/\/+$/, ""); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Poll /api/result jusqu'au résultat (~3 min). Renvoie une Promise<url>.
  function pollTask(ep, id) {
    var attempts = 0, max = 60;
    function poll() {
      attempts++;
      return fetch(ep + "/api/result?id=" + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status === "SUCCEEDED" && j.url) return j.url;
          if (j.status === "FAILED") throw new Error("task_failed");
          if (attempts >= max) throw new Error("timeout");
          return wait(3000).then(poll);
        });
    }
    return poll();
  }

  // Lance la génération (création tâche) puis interroge /api/result jusqu'au résultat.
  // Renvoie une Promise<url>.
  window.MURMURE.generate = function (dataUri, styleId, ratio, prompt, model) {
    var ep = endpoint();
    if (!ep) return Promise.reject(new Error("no_endpoint"));
    return fetch(ep + "/api/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ image: dataUri, style: styleId, prompt: prompt || undefined, ratio: ratio || "1080:1440", model: model || undefined, provider: (window.MURMURE_PROVIDER || undefined) })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || !j.id) throw new Error(j && j.error ? j.error : "create_failed");
        return j.id;
      });
    }).then(function (id) { return pollTask(ep, id); });
  };

  // --- Module « Affiche de ville » ------------------------------------------
  // Cherche une affiche déjà en cache pour cette ville. Renvoie { cached, url, slug }.
  window.MURMURE.cityLookup = function (name) {
    var ep = endpoint();
    if (!ep) return Promise.reject(new Error("no_endpoint"));
    return fetch(ep + "/api/city?name=" + encodeURIComponent(name)).then(function (r) { return r.json(); });
  };
  // Génère une affiche de ville (image Google -> style rétro). Renvoie une Promise<url>.
  window.MURMURE.cityGenerate = function (name) {
    var ep = endpoint();
    if (!ep) return Promise.reject(new Error("no_endpoint"));
    return fetch(ep + "/api/city/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ city: name, provider: (window.MURMURE_PROVIDER || undefined) })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || !j.id) throw new Error(j && j.error ? j.error : "create_failed");
        return j.id;
      });
    }).then(function (id) { return pollTask(ep, id); });
  };
  // Met l'affiche en cache (MinIO) pour les prochains visiteurs. Silencieux.
  window.MURMURE.citySave = function (name, url) {
    var ep = endpoint();
    if (!ep) return Promise.resolve();
    return fetch(ep + "/api/city/save", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ city: name, url: url })
    }).then(function (r) { return r.json(); }).catch(function () {});
  };

  window.MURMURE.enabled = function () { return !!(window.MURMURE_RUNWAY_ENDPOINT || "").trim(); };

  // Temps d'attente minimum (fictif) imposé avant d'afficher l'aperçu, qui s'allonge
  // à chaque tentative (compteur global partagé accueil + page produit) pour
  // décourager la génération en rafale. Réglable depuis Réglages du thème -> Génération IA.
  //   plancher/plafond de la 1re génération, + allongement par tentative, plafonné.
  window.MURMURE._attempts = window.MURMURE._attempts || 0;
  window.MURMURE.throttleDelayMs = function () {
    window.MURMURE._attempts++;
    var n = window.MURMURE._attempts;
    var d = window.MURMURE_DELAY || {};
    var baseMin = (d.min != null ? +d.min : 10);
    var baseMax = (d.max != null ? +d.max : 40);
    var step = (d.step != null ? +d.step : 15);
    var cap = (d.cap != null ? +d.cap : 60);
    var lo = Math.min(baseMin + (n - 1) * step, cap);
    var hi = Math.min(baseMax + (n - 1) * step, cap);
    if (lo > hi) lo = hi;
    if (lo < 0) lo = 0;
    return Math.round((lo + Math.random() * (hi - lo)) * 1000);
  };

  // Messages rassurants qui défilent pendant l'attente (pour que le délai paraisse volontaire).
  window.MURMURE.LOADING_MSGS = [
    "Analyse de votre photo…",
    "Préparation du rendu…",
    "Application du style artistique…",
    "Calage des couleurs…",
    "Harmonisation des détails…",
    "Optimisation de la netteté…",
    "Finalisation de l'aperçu…"
  ];
  // Fait défiler les messages dans l'élément donné ; renvoie une fonction pour arrêter.
  window.MURMURE.cycleMessages = function (el) {
    if (!el) return function () {};
    var msgs = window.MURMURE.LOADING_MSGS, i = 0;
    el.textContent = msgs[0];
    var id = setInterval(function () { i = (i + 1) % msgs.length; el.textContent = msgs[i]; }, 6000);
    return function () { clearInterval(id); };
  };
})();
